import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';

import { MatSelectCountryModule } from '@angular-material-extensions/select-country';
import {
  ForgotPasswordComponent,
  ForgotPasswordFormComponent,
  LoginComponent,
  LoginFormComponent,
  RegistrationFormComponent,
  ResetComponent,
  RestorePasswordFormComponent,
} from '@auth';
import { MzimaUiModule } from '@mzima-client/mzima-ui';
import { TranslateModule } from '@ngx-translate/core';
import {
  DirectiveModule,
  LottieAnimationModule,
  PasswordStrengthModule,
  CountdownTimerModule,
  CountryCodeSelectorModule,
} from '@shared';
import { AuthRoutingModule } from './auth-routing.module';

@NgModule({
  declarations: [
    LoginComponent,
    LoginFormComponent,
    RegistrationFormComponent,
    ForgotPasswordComponent,
    ForgotPasswordFormComponent,
    RestorePasswordFormComponent,
    ResetComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
    MatIconModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatTabsModule,
    LottieAnimationModule,
    DirectiveModule,
    PasswordStrengthModule,
    MzimaUiModule,
    MatSelectCountryModule.forRoot('en'),
    CountryCodeSelectorModule,
    CountdownTimerModule,
  ],
  exports: [LoginFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthModule {}
